import React from 'react';
import { Check } from 'lucide-react';
import { SECTIONS } from '@/constants/testIds';
import { IMG } from '@/lib/assets';

const brangus = [
  'Excelente adaptación al trópico',
  'Alta fertilidad y precocidad',
  'Gran capacidad de crecimiento',
  'Calidad de carne superior',
  'Excelente conversión alimenticia',
];
const sardo = [
  'Rusticidad excepcional',
  'Excelente adaptación al trópico seco',
  'Fertilidad y longevidad',
  'Habilidad materna sobresaliente',
  'Resistencia a parásitos y enfermedades',
];
const comercial = [
  'Adaptación al trópico',
  'Eficiencia alimenticia',
  'Excelente rendimiento',
  'Calidad y consistencia',
  'Resistencia y longevidad',
  'Resultados medibles',
];

export default function Genetica() {
  return (
    <section id="genetica" data-testid={SECTIONS.genetica} className="bg-[#F5EFE0] pb-24">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="gold-divider font-cinzel text-[#A88340] text-xs tracking-[0.3em]">NUESTRAS RAZAS</span>
          <h2 className="font-cormorant text-[#0F3527] text-4xl lg:text-5xl mt-4">
            Genética que define el futuro
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-10">
          <BreedCard
            title="BRANGUS"
            image={IMG.brangusBull}
            description="Raza sintética desarrollada a partir del cruce de Brahman y Angus."
            features={brangus}
          />
          <BreedCard
            title="SARDO NEGRO"
            image={IMG.sardoNegro}
            description="Raza criolla sintética desarrollada en Costa Rica con base en Bos indicus y Bos taurus."
            features={sardo}
          />
        </div>

        <div className="mt-20 text-center mb-10">
          <span className="gold-divider font-cinzel text-[#A88340] text-xs tracking-[0.3em]">
            GANADO COMERCIAL DE ALTO DESEMPEÑO
          </span>
        </div>

        <div className="grid lg:grid-cols-2 gap-10 items-stretch bg-white/60 rounded-sm overflow-hidden border border-[#0F3527]/8 shadow-sm">
          <div className="relative h-72 lg:h-auto min-h-[320px]">
            <img src={IMG.herd} alt="Ganado comercial" className="absolute inset-0 w-full h-full object-cover" />
          </div>
          <div className="p-8 lg:p-12">
            <p className="text-[#0F3527]/85 text-base lg:text-lg leading-relaxed mb-6">
              Programas de cruce que combinan lo mejor del Brangus, ganado blanco y Brahman
              rojo para producir animales adaptados, fértiles, rústicos y altamente productivos.
            </p>
            <div className="grid sm:grid-cols-2 gap-x-6 gap-y-3">
              {comercial.map((f, i) => (
                <div key={i} className="flex items-start gap-3">
                  <span className="check-mark"><Check size={12} strokeWidth={3} /></span>
                  <p className="text-[#0F3527] text-sm">{f}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function BreedCard({ title, image, description, features }) {
  return (
    <div className="bg-white/60 rounded-sm overflow-hidden border border-[#0F3527]/8 shadow-sm hover:shadow-xl transition-shadow duration-500">
      <div className="relative h-72 overflow-hidden">
        <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
      </div>
      <div className="p-8">
        <h3 className="font-cormorant text-3xl text-[#0F3527] tracking-wider mb-3">{title}</h3>
        <p className="text-[#0F3527]/80 mb-5 leading-relaxed">{description}</p>
        <div className="space-y-2.5">
          {features.map((f, i) => (
            <div key={i} className="flex items-start gap-3">
              <span className="check-mark"><Check size={12} strokeWidth={3} /></span>
              <p className="text-[#0F3527] text-[15px]">{f}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
